import React from 'react';

import {
  AdSlot,
  ContainerId,
  type LayoutType,
  type PlacementId,
  type RecommendationCategories
} from '@schibsted-nmp/advertising-shared';

/**
 * This component is used to render an advertising web component, only on the
 * client-side to help with hydration issues.
 */
export function AdvertisingClientWebComponent(
  props: AdvertisingClientWebComponent.Props
) {
  return <AdvertisingClientWebComponent.Forwarded {...props} />;
}

export namespace AdvertisingClientWebComponent {
  export type Props = React.ComponentProps<typeof Forwarded>;

  export const Forwarded = React.forwardRef<HTMLDivElement, Forwarded.Props>(
    ({ placementId, adIndex, initialLayoutType, categories }, ref) => {
      const [clientSide, setClientSide] = React.useState(false);

      React.useEffect(() => {
        setClientSide(true);
      }, []);

      if (!clientSide) return null;

      return (
        <advt-component
          initialLayoutType={initialLayoutType}
          categories={categories}
          adIndex={adIndex}
          placementId={placementId}
        >
          <div
            ref={ref}
            id={ContainerId.fromPlacementId(placementId)}
            slot={AdSlot.fromPlacementId(placementId)}
          ></div>
        </advt-component>
      );
    }
  );

  export namespace Forwarded {
    export type Props = {
      placementId: PlacementId;
      adIndex?: number | undefined;

      /** The categories of the item to get the `placementId` for. */
      categories?: RecommendationCategories | undefined;

      /** The initial layout type of the item to get the `placementId` for. (Grid or List) */
      initialLayoutType?: LayoutType | undefined;
    };
  }
}
